import React from 'react';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import universal from 'react-universal-component';
import styled from 'styled-components';
import { Transition, TransitionGroup } from 'transition-group';
import { loadTopCategories } from '../actions/patterndesignActions';
import { getHeader } from '../reducers/header';
import { getPage, isHomePage, isLandingPage } from '../reducers/page';
import isLoading from '../selectors/isLoading';
import Err from './Error';
import Loading from './Loading';
import MetaData from './MetaData';

import { media } from './styles/breakpoints';
import ErrorBoundary from './common/ErrorBoundary';

defineMessages({
    labelclose: {
        id: 'LABEL_CLOSE',
        description: 'Label for closing a dialog or modal or something like that.',
        defaultMessage: 'schliessen',
    },
    labelcancel: {
        id: 'LABEL_CANCEL',
        description: 'Label for canceling an action or something like that.',
        defaultMessage: 'abbrechen',
    },
    labelaccept: {
        id: 'LABEL_ACCEPT',
        description: 'Label for accepting TOS or something along that line.',
        defaultMessage: 'einverstanden',
    },
    dialogclose: {
        id: 'DIALOG_CLOSE_LABEL',
        description: 'Label for close buttons on dialogs.',
        defaultMessage: 'Schliessen',
    },
    searchgallerytitle: {
        id: 'SEARCH_GALLERY_TITLE',
        description: 'Title prefix for search result page.',
        defaultMessage: 'Stoffe: ',
    },
    newestgallerytitle: {
        id: 'NEWEST_PATTERNGALLERY_TITLE',
        description: 'Title prefix for newest patterns page.',
        defaultMessage: 'Brandneue Stoffe',
    },
    favoritesgallerytitle: {
        id: 'FAVORITES_GALLERY_TITLE',
        description: 'Title prefix for the favorites page.',
        defaultMessage: 'Merkliste: Kurzzeitspeicher für Deine Designerstücke',
    },
    favoritesgalleryhelp: {
        id: 'FAVORITES_GALLERY_HELP',
        description: 'Help text for the favorites page.',
        defaultMessage: 'Warte nicht zu lange und bestell Dir Deine Unikate!',
    },
    favoritesgallerytitleempty: {
        id: 'FAVORITES_GALLERY_TITLE_EMPTY',
        description: 'Title prefix for the favorites page if no patterns are pinned.',
        defaultMessage: 'Deine Merkliste ist leer.',
    },
    favoritesgallerytitletext: {
        id: 'FAVORITES_GALLERY_EMPTY_HELP',
        description: 'Help text for the favorites page if no patterns are pinned.',
        defaultMessage: 'Wir zeigen Dir hier die neuesten Stoff-Motive. Da ist bestimmt eines bei, dass Du magst.',
    },
    sloganfindpatterns: {
        id: 'SLOGAN_FIND_FABRICS',
        defaultMessage: 'Sommer-Stoffe, so einzigartig wie Du selbst ...',
    },
    sloganfindpatternsbottom: {
        id: 'SLOGAN_FIND_FABRICS_BOTTOM',
        defaultMessage: '20000 Stoffe & mehr zum Muttertag ...',
    },
    slogangoandexplore: {
        id: 'CTA_GO_EXPLORE',
        defaultMessage: 'Gar kein Stoff ist auch keine Lösung',
    },
    goandexploretitle: {
        id: 'CTA_EXPLORE_TITLE',
        defaultMessage: 'Stöbern',
    },
    slogangoandexplorefooter: {
        id: 'CTA_GO_EXPLORE_FOOTER',
        defaultMessage: 'Ende... Nun aber stöbern',
    },
    heroCTATitle: {
        id: 'HERO_CTA_TITLE',
        defaultMessage: 'Farbkarte',
    },
    heroCTAText: {
        id: 'HERO_CTA_TEXT',
        defaultMessage: 'Alles was Du brauchst, um Dein eigenes Designerstück zu gestalten.',
    },
    deliveryTime: {
        id: 'PROCESSING_TIME',
        defaultMessage: 'Lieferzeit',
    },
    manufacturing: {
        id: 'MANUFACTURING',
        defaultMessage: 'Verarbeitung',
    },
});


class Contentbase extends React.Component {

    /**
     * Load the categories here. Client only
     * fallback.
     */
    componentDidMount() {
        this.props.loadTopCategories();
    }

    /**
     * We need to prevent rerender of the universal
     * component if the page value doesn't change.
     * Otherwise we get a full rerender of the content
     * part everytime any state changes.
     *
     * @param nextProps
     * @param nextState
     * @returns {boolean}
     */
    shouldComponentUpdate(nextProps, nextState) {
        const update = this.props.page === nextProps.page;
        return !update;
    }

    render() {
        const { page, direction, isLoading, title, isLandingPage, isHomePage, header } = this.props;

        const StyledContent = styled.section`
            &.stolo-main-content {
                margin: ${isLandingPage ? 0 : '0.25rem 1.61rem 1.61rem 1.61rem'};
                
                ${media.wideScreenUpEnd`
                    & h1 {
                      font-size: 3.43rem;
                    }
                    & h2 {
                      font-size: 2.62rem;
                    }
                    & h3 {
                      font-size: 2.12rem;
                    }
                    & h4 {
                      font-size: 1.62rem;
                    }
                    & h5 {
                      font-size: 1.31rem;
                    }
                    & h6 {
                      font-size: 1rem;
                    }
                `}
    
            ${media.wideScreenUp`
                & h1 {
                  font-size: calc(1.602rem + ( 38 - 22  ) * (100vw - 320px) / (1200 - 320));
                }
                & h2 {
                  font-size: calc(1.424rem  + ( 36 - 19  ) * (100vw - 320px) / (1200 - 320));
                }
                & h3 {
                  font-size: calc(1.266rem + ( 30 - 18 ) * (100vw - 320px) / (1200 - 320));
                }
                & h4 {
                  font-size: calc(1.266rem + ( 30 - 18 ) * (100vw - 320px) / (1200 - 320));
                }
                & h5 {
                  font-size: calc(1rem + ( 22 - 14 ) * (100vw - 320px) / (1200 - 320));
                }
                & h6 {
                  font-size: calc(0.889rem + ( 18 - 12 ) * (100vw - 320px) / (1200 - 320));
                }
            `}
        }

           & .stolo-help {
             padding: ${props => props.theme.space[8]};
             margin: ${props => props.theme.space[8]} ${
            props => props.theme.space[12]} ${props => props.theme.space[8]} ${
            props => props.theme.space[8]};
             border: 1px solid ${props => props.theme.palette.blueGrey[500]};
           }

           & .stolo-info {
             padding: ${props => props.theme.space[8]};
             margin: ${props => props.theme.space[8]} ${
            props => props.theme.space[12]} ${props => props.theme.space[8]} ${
            props => props.theme.space[8]};
             border: 2px solid ${props => props.theme.palette.primary[500]};
           }

           & .stolo-warn {
             padding: ${props => props.theme.space[8]};
             margin: ${props => props.theme.space[8]} ${
            props => props.theme.space[12]} ${props => props.theme.space[8]} ${
            props => props.theme.space[8]};
             background: ${props => props.theme.palette.secondary[50]};
             border: 2px solid ${props => props.theme.palette.secondary[500]};
           }

           & .stolo-error {
             padding: ${props => props.theme.space[8]};
             margin: ${props => props.theme.space[8]} ${
            props => props.theme.space[12]} ${props => props.theme.space[8]} ${
            props => props.theme.space[8]};
             background: ${props => props.theme.palette.secondary[500]};
             border: 2px solid ${props => props.theme.palette.secondary.A100};
             color: white;
           }
           
           & .stolo-inner-text {
             max-width: ${props => props.theme.space[25]};
             margin-right: auto;
             margin-left: auto;
           }
           
           & .stolo-hidden {
              visibility: hidden;
              display: none;
           }

           & .stolo-inner-content {
               width: 100%;
               max-width: 100em;
               margin-right: auto;
               margin-left: auto;
           }
           
          & .clearfix:after {
            content: ".";
            visibility: hidden;
            display: block;
            height: 0;
            clear: both;
          }

        `;

        const UniversalComponent = universal(
            ({ page }) => import(`./async/${page}`), {
                minDelay: 500,
                loading: Loading,
                error: Err,
            });

        const Switcher = ({ page, direction, isLoading }) => <TransitionGroup
            className={`${direction}`}
            duration={500}
            prefix='fade'
        >
            <Transition key={page}>
                <UniversalComponent page={page} isLoading={isLoading} />
            </Transition>
        </TransitionGroup>;


        const UniversalHeader = universal(
            ({ header }) => import(`./header/${header}`), {
                minDelay: 100,
                loading: Loading,
                error: Err,
            });

        const HeaderSwitcher = ({ header, direction }) => <TransitionGroup
            className={`${direction}`}
            duration={500}
            prefix='fade'
        >
            <Transition key={header}>
                <UniversalHeader header={header} isLoading={false} />
            </Transition>
        </TransitionGroup>;

        return (
            <div>
                <MetaData page={page} />
                <HeaderSwitcher header={header} direction={direction} />
                <ErrorBoundary>
                <StyledContent className='stolo-main-content'>
                    <Switcher
                        page={page}
                        direction={direction}
                        isLoading={isLoading}
                    />
                </StyledContent>
                </ErrorBoundary>
            </div>
        );
    }

}


const mapDispatchToProps = {
    loadTopCategories,
};

const mapStateToProps = ({ direction, ...state }) => (
    {
        direction,
        page: getPage(state),
        header: getHeader(state),
        isLoading: isLoading(state),
        isLandingPage: isLandingPage(state),
        isHomePage: isHomePage(state),
    }
);

export default connect(mapStateToProps, mapDispatchToProps)(Contentbase);




// WEBPACK FOOTER //
// ./src/components/Contentbase.js